module.exports = __webpack_public_path__ + "media/fonts/american_typewriter-webfont-993a0e10fe3adfeb716eaa2ee98aebf8.ttf";